{
  "coach": {
    "activityDialog": {
      "title": "Activity",
      "description": "The activity Blinky opened in your coaching session."
    },
    "blinky": "Blinky",
    "blinkyLoading": "Getting ready…",
    "activeNow": "Active now",
    "heading": "Coach",
    "chat": {
      "thinking": "Blinky’s thinking…",
      "placeholder": "Ask me anything",
      "error": "That didn’t go through. Give it another try.",
      "retry": "Try again",
      "failed": {
        "reply": "That one didn’t reach me.",
        "birth": "We didn’t get started there.",
        "send": "That didn’t send.",
        "retry": "Try again"
      },
      "youSaid": "You said:",
      "blinkySaid": "Blinky said:",
      "feedLabel": "Conversation with Blinky"
    },
    "chatInput": {
      "label": "Chat message",
      "send": "Send",
      "voiceStart": "Start voice input",
      "voiceStop": "Stop voice input",
      "listening": "Listening…",
      "voiceErrorPermission": "Microphone access is blocked — check your browser settings",
      "voiceErrorGeneric": "Voice input didn't work — please type instead"
    },
    "goal": {
      "achieved": "Goal achieved",
      "none": "No goal yet",
      "noneDescription": "Chat with Blinky to set one."
    },
    "goalMarker": {
      "set": "Goal set",
      "updated": "Goal updated",
      "achieved": "Goal achieved",
      "previous": "Was: {goalTitle}"
    },
    "institutionCard": {
      "addFavouriteAriaLabel": "Save {institutionTitle} to your favorites",
      "removeFavouriteAriaLabel": "Remove {institutionTitle} from your favorites"
    },
    "lessons": {
      "seeAll": "See all your lessons",
      "pageTitle": "My Lessons",
      "pageSubtitle": "Work your teachers assigned you, and more from your school.",
      "outstandingHeading": "To do",
      "exploreHeading": "More from your school",
      "doneHeading": "Done ({count})",
      "setByTeacher": "Assigned to you by your teacher",
      "fromYourSchool": "From your school",
      "opening": "Opening your lesson…",
      "openingNamed": "Opening {lesson}…",
      "unavailable": "That lesson isn’t available anymore. Your list has been updated.",
      "busy": "Your coach is finishing something. Try again in a moment.",
      "empty": {
        "title": "Nothing assigned yet",
        "description": "When your school assigns you a lesson, you’ll find it here."
      },
      "replace": {
        "title": "Start this lesson?",
        "body": "This will end your current chat and start {lesson}.",
        "consequence": "You’ll see a recap of this chat at the top of the new one.",
        "confirm": "Start lesson",
        "cancel": "Keep chatting"
      }
    },
    "progress": {
      "searchJobs": {
        "roundingUp": "Rounding up some jobs…",
        "outThere": "Seeing what’s out there…",
        "throughCareers": "Looking through careers…"
      },
      "searchInstitutions": {
        "placesToStudy": "Looking up places to study…",
        "whoTeaches": "Checking who teaches this…",
        "studyOptions": "Scanning study options…"
      },
      "searchContent": {
        "worthReading": "Digging up something worth reading…",
        "library": "Scanning the library…",
        "goodRead": "Finding you a good read…"
      },
      "getJobDetails": {
        "closerLook": "Taking a closer look…",
        "intoDetail": "Getting into the detail…"
      },
      "getInstitutionDetails": {
        "readingUp": "Reading up on this one…",
        "closerLook": "Taking a closer look…"
      }
    },
    "question": {
      "submit": "Submit",
      "typeHint": "Tap one, or type your own answer",
      "outcome": {
        "lapsed": "You moved on"
      }
    },
    "rail": {
      "exploreLibrary": "Browse the whole library"
    },
    "recap": {
      "title": "Last session",
      "titleSwitched": "Before you switched goals",
      "noGoal": "No goal was set",
      "noSummary": "This one wrapped up before there was much to sum up.",
      "endReason": {
        "ABANDONED": "Left open",
        "GOAL_SWITCHED": "Moved to a new goal",
        "SUPERSEDED": "Replaced",
        "USER_ENDED": "You ended it"
      }
    },
    "school": {
      "setBy": "Assigned by {school}"
    },
    "seo": {
      "title": "Coach | Anyway",
      "page": {
        "account": "Account",
        "badges": "Badges",
        "institutions": "Institutions",
        "jobCandidates": "My Pathways",
        "jobs": "Jobs",
        "learn": "Learn",
        "lessons": "My Lessons",
        "portfolio": "Portfolio",
        "profile": "Profile",
        "rewards": "Rewards",
        "saved": "Saved"
      }
    },
    "session": {
      "end": {
        "label": "End session",
        "confirm": {
          "title": "Wrap this up?",
          "body": "I’ll save what we covered.",
          "confirm": "End session",
          "cancel": "Keep going",
          "consequence": "You’ll see a recap at the top of your next chat, and you can start again any time."
        }
      }
    },
    "starters": {
      "typeHint": "Or just type what’s on your mind"
    },
    "stillThinking": "Still thinking…",
    "typing": "Thinking…"
  }
}
